/**
 * Vite proxy targets. Each backend service gets a regex key that requires a
 * path-segment boundary (`/` or end-of-string) AFTER the service name. This
 * stops the proxy from grabbing SPA routes whose paths happen to start with
 * the service name plus extra characters — e.g. `/order` proxy must not
 * intercept the SPA's `/orders/:id` route.
 * Kept in its own module so unit tests can import the patterns directly.
 */

/** Where local dev forwards every backend segment unless `.env.local` overrides it. */
export const DEFAULT_PROXY_TARGET = 'https://api.dev.ordermesh.io';

export const proxyTargets = [
  'ai',
  'catalog',
  'history',
  'insight',
  'integration',
  'merchant',
  'notification',
  'inventory',
  'template',
  'order',
  'workflow',
  'sse',
  'routing',
  'shipment',
  'transformation',
  'user',
  'vendor',
  'files',
  'config',
  'note',
  'carrier',
  'sku',
  'pricing',
] as const;

export function proxyKeyFor(segment: string): string {
  return `^/${segment}(?:/|$)`;
}

export function buildProxyKeys(targets: readonly string[] = proxyTargets): string[] {
  return targets.map(proxyKeyFor);
}
